import { useState } from 'react';
import { Alert, Text } from '@mantine/core';
import { IconDeviceIpad } from '@tabler/icons-react';
import { isIOS, isStandalone } from '../infra/browser';
import { Brand } from '../ui/Brand';

const KEY = 'flow.installHintDismissed';

/** iOS evicts website data after ~7 days unused unless the app is added to the Home Screen. */
export const InstallHint = () => {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(KEY) === '1';
    } catch {
      return false;
    }
  });
  if (dismissed || !isIOS() || isStandalone()) return null;
  return (
    <Alert
      icon={<IconDeviceIpad size={18} />}
      title={<>Install <Brand /> on this iPad</>}
      withCloseButton
      onClose={() => {
        setDismissed(true);
        try {
          localStorage.setItem(KEY, '1');
        } catch { /* ignore */ }
      }}
      radius={0}
    >
      <Text size="sm">
        Tap Share → <b>Add to Home Screen</b>, then open <Brand /> from the Home Screen. It works offline and keeps your data safe.
        (Data saved in a Safari tab can be cleared by iOS, and the installed app has its own separate storage.)
      </Text>
    </Alert>
  );
};
